<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "App",
  created() {
    if (localStorage.wxpyqToken) {
      const decode = localStorage.wxpyqToken;
      this.$store.dispatch("setUser", decode);
    }
  },
};
</script>
<style>
/* http://meyerweb.com/eric/tools/css/reset/ 
   v2.0 | 20110126
   License: none (public domain)
*/

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

body,
html {
  /* height: 100%; */
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  font-size: 14px;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: transparent;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
  overflow: auto !important;
  padding-right: 0 !important;
}
ol,
ul {
  list-style: none;
}
a {
  text-decoration: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}

#app {
  background-color: #f6f7f8;
}

#app .index-container,
#app .home-container {
  width: 100%;
  height: 100%;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cursor-default {
  cursor: default;
}

.flex {
  display: flex;
}

.el-main {
  padding: 0;
}

.el-loading-mask {
  z-index: 1500;
}

.image-previewer-wrapper .prev-button {
  left: 50px !important;
}

.image-previewer-wrapper .next-button {
  right: 50px !important;
}

.handlian-nav li:first-child {
  padding-left: 0;
}

.user-info-wrapper .el-icon-arrow-down {
  right: 0;
}

.el-submenu__title {
  padding-left: 0;
}

.el-textarea .el-input__count {
  line-height: 12px;
}

.handlian-all-reply .el-dialog__body {
  height: 50vh;
  padding: 10px 20px;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  border-top: 1px solid #f6f6f6;
}

.handlian-all-reply .el-dialog__footer {
  padding-bottom: 10px;
}

.handlian-all-reply .el-dialog__title {
  font-size: 16px;
}

.handlian-report-container .el-dialog__body {
  padding: 10px 20px;
  border-top: 1px solid #f6f6f6;
}

.handlian-share-article .el-dialog__body {
  padding: 10px 20px;
  border-top: 1px solid #f6f6f6;
}

.handlian-report-container .el-dialog__title {
  font-size: 16px;
}

.handlian-share-article .el-dialog__title {
  font-size: 16px;
}

.handlian-report-container .el-radio {
  width: 25%;
  line-height: 40px;
}

.handlian-suggest-container .el-dialog__body {
  padding: 10px 20px;
  border-top: 1px solid #f6f6f6;
}

.handlian-suggest-container .el-dialog__title {
  font-size: 16px;
}

.handlian-comment-container .el-dialog__body {
  height: 545px;
  padding: 0 0 0 6px;
  overflow-x: hidden;
  box-sizing: border-box;
  border-top: 1px solid #f6f6f6;
}

.handlian-comment-container .el-dialog__title {
  font-size: 16px;
  line-height: 22px;
}

.handlian-comment-container .el-dialog__headerbtn {
  top: 14px;
}

.handlian-comment-container .el-dialog__header {
  padding-top: 10px;
}

.handlian-inform-container .el-dialog__body {
  height: 545px;
  padding: 0;
  overflow-x: hidden;
  border-top: 1px solid #cccccc;
}

.handlian-inform-container .el-dialog__title {
  font-size: 16px;
  line-height: 22px;
}

.handlian-inform-container .el-dialog__headerbtn {
  top: 14px;
}

.handlian-inform-container .el-dialog__header {
  padding-top: 10px;
}

.el-submenu__title:hover {
  background-color: #ffffff;
}

.el-menu--horizontal .el-menu-item.hd-i-nav:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item.hd-i-nav:not(.is-disabled):hover {
  outline: 0;
}

.el-menu--horizontal > .el-menu-item.hd-i-nav:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item.hd-i-nav:not(.is-disabled):hover {
  background-color: unset;
}

.el-popup-parent--hidden {
  overflow: auto;
}

.handlian-select {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}

.handlian-select option {
  font-size: 16px;
}

.message-aside {
  position: fixed;
  right: 0;
  top: 0;
  width: 50px;
  height: 210px;
  background-color: #f6f7f8;
  border-left: 1px solid #f1f2f4;
  z-index: 5;
}

.el-upload-list__item-thumbnail {
  object-fit: cover;
}

.ad-image-item img {
  object-fit: cover;
}

.message-menu-wrapper {
  margin-top: 60px;
}

.account-item .el-collapse-item__header {
  height: 30px;
  line-height: 30px;
}

.account-item .is-active {
  background-color: #dcecff;
}

.tree-item .el-collapse-item__header {
  height: 30px;
  line-height: 30px;
}

.tree-item .is-active {
  background-color: #dcecff;
}

.space-progress-wrap .el-progress-bar__innerText {
  color: #000;
  font-weight: bold;
}

.profile-item-content .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  border-color: #dcdfe6;
  color: #000;
}

.profile-item-content .el-radio__input.is-disabled + span.el-radio__label {
  color: #000;
  cursor: not-allowed;
}

.profile-form-item .el-form-item__label {
  font-size: 16px;
}

.profile-form-item .el-input {
  font-size: 16px;
}

.handlian-cropper-container .el-dialog__title {
  font-size: 16px;
}

.handlian-cropper-container .el-dialog__body {
  padding: 10px 20px;
  border-top: 1px solid #f6f6f6;
}

.steps-container .el-step__title {
  font-size: 16px;
  line-height: 30px;
}

.steps-container .el-step__title.is-process {
  color: #ff9800;
}

.steps-container .el-step__head.is-process {
  color: #ff9800;
  border-color: #ff9800;
}

.handlian-btn {
  padding: 7px 10px;
}

.cl-hide-production {
  width: 315px;
}
.cl-hide-production .el-message-box__message p,
.cl-edit-profile .el-message-box__message p {
  white-space: pre-line;
}

.cl-edit-profile {
  width: 350px;
}

.tree-member-change {
  width: 400px;
}

.tree-member-change .el-message-box__message {
  font-size: 16px;
}

.handlian-loading-detail .el-dialog__header {
  padding: 0;
}

.el-collapse:empty {
  border: none;
}

.share-form-item {
  margin-bottom: 5px;
}

.share-check-box {
  display: flex;
  align-items: center;
}

.share-check-box .el-checkbox__label {
  display: flex;
  align-items: center;
}

.share-user-avatar {
  width: 30px;
  height: 30px;
  margin-right: 5px;
  border-radius: 3px;
}

.handlian-share-feed .el-dialog__title {
  font-size: 16px;
}

.handlian-share-feed .el-dialog__body {
  padding: 0 20px 10px;
}

/* 登录表单 */

.login-form-container .el-tabs__nav {
  width: 100%;
}

.login-form-container .el-tabs__nav .el-tabs__item {
  width: 50%;
  padding: 0;
  font-size: 16px;
  text-align: center;
}

.login-form-container .el-tabs__nav-wrap::after {
  /*未选中的Tab 底部线条*/
  background-color: #ffffff;
}

/* 注册表单 */

.regist-address-wrap .el-form-item__content {
  display: flex;
}

.regist-form-item .el-form-item__label {
  font-size: 16px;
}

.agreement-wrap .el-form-item__content {
  margin-bottom: 5px;
  line-height: 19px;
}

.regist-address-container .el-form-item:nth-child(1) {
  width: 380px;
}

.regist-address-container .el-form-item:nth-child(2) {
  margin: 0 5px;
}

.regist-address-container .el-form-item:nth-child(2) .el-form-item__content {
  margin-left: 0 !important;
}

.regist-address-container .el-form-item:nth-child(3) .el-form-item__content {
  margin-left: 0 !important;
}

.handlian-agreement-dialog .el-dialog__title {
  font-size: 16px;
}

.handlian-agreement-dialog .el-dialog__body {
  padding: 0;
  border-top: 1px solid #f6f6f6;
}

.regist-form-item .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  border-color: #dcdfe6;
  color: #000;
}

/* 亲人资料 */

.relative-date-container .el-form-item:nth-child(1) {
  width: 350px;
}

.relative-date-container .el-form-item:nth-child(2) {
  margin: 0 3px 0 6px;
}

.relative-date-container .el-form-item:nth-child(3) {
  margin: 0 6px 0 3px;
}

.relative-date-container .el-form-item:nth-child(2) .el-form-item__content {
  margin-left: 0 !important;
}

.relative-date-container .el-form-item:nth-child(3) .el-form-item__content {
  margin-left: 0 !important;
}

.relative-date-container .el-form-item:nth-child(4) .el-form-item__content {
  margin-left: 0 !important;
}

.profile-dropdown-wrap .el-dropdown {
  color: #fff;
  font-size: 16px;
}

.profile-dropdown-wrap .el-dropdown.non-option {
  color: #1a70db;
}

.relative-date-select .el-icon-arrow-up:before {
  content: none;
}

.wait-member-container .hl-form-inline .el-input {
  width: 150px;
}

.handlian-copy-tree .el-dialog__header {
  padding: 5px 20px 5px;
}

.handlian-copy-tree .el-dialog__title {
  font-size: 16px;
  line-height: 20px;
}

.handlian-copy-tree .el-dialog__body {
  padding: 0;
}

.handlian-copy-tree .el-dialog__headerbtn {
  top: 6px;
  right: 10px;
}

.handlian-copy-tree .copy-tree-form .el-input {
  width: 150px;
}

.handlian-copy-tree .copy-tree-form .el-form-item__label {
  font-size: 16px;
}

.cl-copy-confirm .el-message-box__message p {
  white-space: pre-line;
  font-size: 16px;
}

.cl-copy-confirm .el-message-box__title {
  font-size: 16px;
}

.admin-feed-container img,
.admin-feed-container video {
  max-width: 100%;
}

.cl-upload-control .el-upload-list__item {
  width: 130px;
  height: 130px;
  margin-right: 5px;
  margin-bottom: 5px;
}

.cl-upload-control .el-upload--picture-card {
  width: 130px;
  height: 130px;
  line-height: 135px;
}

.goods-cover-wrap img {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
</style>
